"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const clsx_1 = require("clsx");
const app_1 = require("app");
const index_1 = require("../index");
const Picture_1 = require("../../Picture");
const TileImageDefault_1 = require("./TileImageDefault");
const TileImage = ({ defaultImageType, image: imageUrl, altText, title, tileShape, hasCardHoverEffect, isSearchResult, }) => {
    const isWide = tileShape === index_1.TileShapeEnum.Wide;
    const isWideSmall = tileShape === index_1.TileShapeEnum.WideSmall;
    const { pictureSet, width } = React.useMemo(() => {
        const DEFAULT_IMAGE_WIDTH = 300;
        let pictureSet;
        let width;
        if (isWide) {
            pictureSet = index_1.TilePictureSet.Wide;
            width = 300;
        }
        else if (isWideSmall) {
            pictureSet = index_1.TilePictureSet.WideSmall;
            width = 270;
        }
        else if (tileShape === index_1.TileShapeEnum.Card) {
            pictureSet = index_1.TilePictureSet.Card;
            width = 409;
        }
        else if (tileShape === index_1.TileShapeEnum.CardBig) {
            pictureSet = index_1.TilePictureSet.CardBig;
            width = 626;
        }
        else {
            width = DEFAULT_IMAGE_WIDTH;
        }
        return { pictureSet, width };
    }, [tileShape]);
    let componentPictureSet = pictureSet || index_1.TilePictureSet.Wide;
    if (!imageUrl && !(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.length) && !!defaultImageType) {
        return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.clsx)('overflow-hidden', isSearchResult && 'sm:min-w-[270px] aspect-[3/2]', isWideSmall && !isSearchResult ? 'h-auto xs:h-full bg-fill-primary' : 'aspect-[3/2]'), children: (0, jsx_runtime_1.jsx)(TileImageDefault_1.default, { tileShape: tileShape, defaultImageType: defaultImageType, altText: altText, hasCardHoverEffect: hasCardHoverEffect }) }));
    }
    if (!imageUrl && !(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.length)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, app_1.cn)('image-skeleton-loading relative overflow-hidden aspect-[3/2]', isWideSmall && !isSearchResult && 'h-auto sm:h-full bg-fill-primary aspect-auto', isWide || isWideSmall
            ? 'image-skeleton-loading-right-bordered'
            : 'image-skeleton-loading-bottom-bordered', isSearchResult && 'image-skeleton-loading-h-full sm:w-[270px]'), children: (0, jsx_runtime_1.jsx)(Picture_1.Picture, { url: imageUrl, altText: altText, title: title, width: width, set: componentPictureSet, className: (0, app_1.cn)('w-full h-full object-cover transition-[opacity,scale] duration-300 ease-in-out', hasCardHoverEffect && 'group-hover:scale-110', isWide && 'sm:w-[300px] sm:min-w-[300px]', isWideSmall && 'max-w-auto sm:w-[270px] h-auto object-contain', isSearchResult && 'sm:w-full h-full object-contain') }) }));
};
exports.TileImage = TileImage;
